module.exports = __webpack_public_path__ + "img/WM_licenseback.2c40ad81.png";